import type { BaseUsecase } from '@usecases/base-usecase';

export type MuteToggleRequest = boolean;

export interface MuteToggleEventPublisher {
  publish(onMute: boolean): Promise<void>;
}

export interface MuteToggleUsecase
  extends BaseUsecase<MuteToggleRequest, void> {
  run(call: MuteToggleRequest): Promise<void>;
}

export class MuteToggle implements MuteToggleUsecase {
  constructor(private publisher: MuteToggleEventPublisher) {}

  async run(req: MuteToggleRequest): Promise<void> {
    this.publisher.publish(req);
  }
}
